<template>
  <div class="course-title-box">
    <div
      class="course-title"
      v-if="title !== ''"
      v-html="title"
      :style="{ '--titleColor': titleColor ? titleColor : '#24375c' }"
    ></div>
    <div
      class="course-text"
      v-if="text"
      v-html="text"
      :style="{ '--titCorol': titColor ? titColor : '#4e5969' }"
    ></div>
  </div>
</template>

<script>
export default {
  props: ["title", "text", "titleColor", "titColor"],
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.course-title-box {
  position: relative;
  z-index: 20;
  .course-title {
    font-size: 40px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: center;
    color: #24375c;
    line-height: 56px;
    color: var(--titleColor);
  }
  .course-text {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: center;
    color: #4e5969;
    line-height: 40px;
    margin-top: 16px;
    color: var(--titCorol);
  }
}
</style>
